export const get_phone_digits = (phone: string) => phone.replace(/\D/g, ``)
